<template minapp="mpx" xlang="wxml">
  <view class="card" wx:style="{{notSale ? 'color: #999999' : ''}}">
    <view class="card-main" bindtap="chooseTrain">
      <view class="off-sale" wx:if="{{notSale}}">
        <view class="off-sale-text">暂停发售</view>
      </view>
      <view class="card-item" wx:style="{{notSale ? 'alignItems: center' : ''}}">
        <view class="train-info start">
          <view class="time" wx:if="{{!notSale}}">{{ startTime }}</view>
          <view class="sizebox"></view>
          <view class="train-code start">
            <view class="station-name" wx:style="{{notSale ? 'color: #999999' : ''}}">{{
              trainInfo.from_station_name
            }}</view>
            <view wx:if="{{!isTransfer}}" class="station-dot from">
              {{ trainInfo.is_start_station == 1 ? '始' : '过' }}
            </view>
          </view>
        </view>
        <view
          wx:if="{{!isTransfer}}"
          class="train-info center"
          wx:style="{{notSale ? 'flex: 2' : ''}}"
        >
          <view
            class="station-info station-info-up"
            wx:style="{{'color: #999999'}}"
            wx:if="{{notSale}}"
            >{{ notSaleMsg }}</view
          >
          <view class="station-info station-info-up" wx:else>{{ duration }}</view>
          <image
            class="img"
            src="https://dpubstatic.udache.com/static/dpubimg/giRx8tUEEvhUyA8DGud3G.png"
          ></image>
          <view class="train-code">
            <view
              class="station-info station-info-bottom"
              wx:style="{{notSale ? 'color: #999999' : ''}}"
              >{{ trainInfo.train_code }}</view
            >
            <view
              class="station-dot"
              wx:if="{{showSilent && !notSale}}"
              wx:style="{{{marginLeft: '2px'}}}"
            >
              静
            </view>
            <view
              class="station-dot fuxing"
              wx:if="{{showFxh && !notSale}}"
              wx:style="{{{marginLeft: '2px'}}}"
            >
              复兴号
            </view>
            <view
              class="station-dot zndc"
              wx:if="{{ShowZndc && !notSale}}"
              wx:style="{{{marginLeft: '2px'}}}"
            >
              智能动车
            </view>
          </view>
        </view>
        <view wx:else class="train-info center" wx:style="flex: none">
          <view
            class="station-info station-info-up transfer-top"
            wx:style="{{'color: #999999'}}"
            wx:if="{{notSale}}"
            >{{ notSaleMsg }}</view
          >
          <view class="station-info station-info-up transfer-top" wx:else>{{ duration }}</view>
          <view class="station-info station-info-up transfer-center">
            <view class="container">
              <image
                class="icon"
                src="https://ut-static.udache.com/webx/sfc/0qPjtyLL21lQO8Nx3Jpqi.png"
              />
              <text>{{ transferStation }}</text>
            </view>
            <image
              class="img"
              src="https://ut-static.udache.com/webx/sfc/99qi9qFGZ22U7XTX3jubR.png"
            ></image>
          </view>
          <view class="station-info station-info-up transfer-bottom">
            <text wx:class="{{isTransferDif && 'transfer-different'}}">{{ transferSameText }}</text>
            <text>·{{ transferTime }}</text>
          </view>
        </view>
        <view class="train-info arrive">
          <view class="time arrive" wx:if="{{!notSale}}"
            >{{ endTime }}
            <view wx:if="{{trainInfo.day_difference > 0}}" class="day-diff">{{
              `+${trainInfo.day_difference}天`
            }}</view>
          </view>
          <view class="sizebox"></view>
          <view class="train-code end">
            <view wx:if="{{!isTransfer}}" class="station-dot to">
              {{ trainInfo.is_end_station == 1 ? '终' : '过' }}
            </view>
            <view class="station-name" wx:style="{{notSale ? 'color: #999999' : ''}}">{{
              trainInfo.to_station_name
            }}</view>
          </view>
        </view>
        <view class="train-info price" wx:if="{{!notSale}}">
          <view class="train-code" wx:style="{{ isScramble ? 'marginTop: 13px' : '' }}">
            <view class="price small" wx:if="{{!(sellOut && fromChangeTicket)}}">¥ </view>
            <view wx:style="margin-right: 2px; "></view>
            <view class="price noSeat" wx:if="{{sellOut && fromChangeTicket}}">无票</view>
            <view class="price large" wx:else>
              {{ lowestPrice.displayedPrice }}
              <text wx:if="{{isStudentType && !isScramble}}" class="start-text">起</text>
            </view>
          </view>
          <!-- 已减多少钱的 tag -->
          <view wx:if="{{lowestPrice.couponDesc}}" class="coupon-desc">
            {{ lowestPrice.couponDesc }}
          </view>
          <!-- 划线价 -->
          <crossed-price
            prefix="官方"
            class="original-price"
            wx:if="{{isShowCrossedPrice}}"
            price="{{lowestPrice.originalPrice}}"
          />
        </view>
        <view class="scramble-choose-icon" wx:if="{{isScramble}}" wx:style="{{iconStyle}}"></view>
      </view>
      <block wx:if="{{!isTransfer}}">
        <view wx:if="{{notSaleNow || isPreScramble }}" class="halt-sales-tips">
          <rich-text nodes="{{saleMsg}}"></rich-text>
        </view>
        <view wx:elif="{{sellOut && !saleFlag && !fromChangeTicket}}" class="sell-out-tips">
          车票已售罄，新人可享免费高速抢票
        </view>
        <view class="grid-container" wx:else>
          <view wx:for="{{refactorTicketInfo}}" wx:key="index" wx:class="{{ item.style}}">
            <text>{{ item.seat_type_name }}</text>
            <text wx:class="{{{'grab-ticket': item.ticket_num === '无票' && !fromChangeTicket}}}">{{
              ' ' + (item.ticket_num === '无票' && !fromChangeTicket ? '抢票' : item.ticket_num)
            }}</text>
          </view>
        </view>
      </block>
      <view wx:else>
        <view
          class="transfer-ticket-container"
          wx:for="{{transferTikcetArr}}"
          wx:key="index"
          wx:for-item="train"
        >
          <view class="placeholder">
            <view class="train-no">
              {{ transferTrainInfo(train) }}
            </view>
          </view>
          <view class="transfer-seat-container">
            <view
              class="transfer-seat"
              wx:class="{{{gray: item.ticket_num === '无票'}}}"
              wx:for="{{train.ticket_data}}"
            >
              {{ `${getSeatName(item.seat_type_name)} ${item.ticket_num}` }}
            </view>
          </view>
        </view>
      </view>
    </view>
    <recommend-ticket
      trainInfo="{{trainInfo}}"
      recommendTicket="{{recommendTicket}}"
      recommendTicketDrawer="{{recommendTicketDrawer}}"
      wx:if="{{recommendTicket && !fromChangeTicket }}"
    />
  </view>
</template>

<script>
import { createComponent, mpx } from '@didi/es-mpx-creator'
import { parseDate, formatDate } from '@/utils/baseDate'
import { getPadPrice, getFinalPrice } from '@/utils/money'
import store from '@/store'
import { getStorage } from '@/utils/storage'
import { formatRecommendTicket, formatRecommendTicketDrawer } from '@/utils/recommend'
import { STORAGE_LIST_SEARCH_QUERY } from '@/utils/train-storage'

createComponent({
  props: {
    trainInfo: Object,
    isScramble: Boolean,
    include: Boolean,
    current: String,
    fromChangeTicket: Boolean
  },
  computed: {
    refactorTicketInfo() {
      return this.trainInfo?.ticket_data?.map?.((item) => {
        var index = this.trainInfo?.ticket_data?.indexOf(item)
        if (index % 4 === 1) {
          item.style = 'ticket-style-1 ticket'
        } else if (index % 4 === 3 || index % 4 === 2) {
          item.style = 'ticket-style-2 ticket'
        } else {
          item.style = 'ticket'
        }
        if (item.ticket_num === '无票') {
          item.style = item.style + ' noTicket'
        } else {
          item.style = item.style + ' hasTicket'
        }
        return item
      })
    },
    // 是否为中转
    isTransfer() {
      return this.trainInfo?.transfer_ticket && this.trainInfo?.transfer_ticket?.length > 0
    },
    saleMsg() {
      // const list = this.normalTexts.map((item) => this.getTemplate('#333333', item))
      let msg = this.trainInfo?.sale_msg || ''
      // let msg = '次暂未发售，预计%s2月15日8点30分%s起售'
      const list = msg?.split('#') || []
      list[0] = this.getTemplate('#666666', list?.[0])
      list[1] = this.getTemplate('#FF4129', list?.[1])
      list[2] = this.getTemplate('#666666', list?.[2])
      return list
    },
    lowestPrice() {
      let priceIdex = 0
      var price = Number.MAX_VALUE
      if (this.isTransfer) {
        let maxPrice = Number.MAX_VALUE
        const price = this.trainInfo?.transfer_ticket?.reduce((total, segment) => {
          const prices = segment.ticket_data
            .map((ticket) => +ticket.ticket_price)
          const minPrice = Math.min(...prices)
          return total + minPrice
        }, 0)
        this.trainInfo?.transfer_ticket[0]?.ticket_data?.forEach((item, index) => {
          if (eval(+item.ticket_price) < eval(+maxPrice)) {
            maxPrice = +item.ticket_price
            priceIdex = index
          }
        })
        const curPrice = this.trainInfo?.transfer_ticket[0]?.ticket_data[priceIdex]
        const showPirce = this.trainInfo?.show_price
        return price === showPirce ? { displayedPrice: getFinalPrice(price) } : {
           originalPrice: getFinalPrice(price),
           couponDesc: curPrice?.discount_desc,
           displayedPrice: getFinalPrice(showPirce)
        }
      } else {
        this.trainInfo?.ticket_data?.forEach((item, index) => {
          if (eval(item.ticket_price) < eval(price)) {
            price = item.ticket_price
            priceIdex = index
          }
        })
        // 当前展示价格的目标对象
        const curPrice = this.trainInfo?.ticket_data?.[priceIdex]
        return price === Number.MAX_VALUE
          ? { displayedPrice: getFinalPrice(0) }
          : {
              originalPrice: getFinalPrice(price),
              couponDesc: curPrice?.discount_desc,
              displayedPrice: getFinalPrice(
                curPrice?.coupon_after_price || curPrice?.coupon_after_price === 0
                  ? curPrice?.coupon_after_price
                  : price
              )
            }
      }
    },
    // 是否展示划线价格
    isShowCrossedPrice() {
      return (
        this.lowestPrice?.originalPrice &&
        this.lowestPrice.displayedPrice !== this.lowestPrice.originalPrice
      )
    },
    duration() {
      const str = this.trainInfo?.travel_time_name
      return str.substring(2, str.length)
    },
    startTime() {
      return this.getTimeFromDate(this.trainInfo.start_time)
    },
    endTime() {
      return this.getTimeFromDate(this.trainInfo.arrive_time)
    },
    saleFlag() {
      return this.trainInfo?.sale_flag
    },
    notSaleMsg() {
      return this.trainInfo?.sale_msg
    },
    notSale() {
      // 暂停发售
      // e.g. 列车运行图调整,暂停发售
      return this.saleFlag && !this.trainInfo?.ticket_data
    },
    isPreScramble() {
      return this.trainInfo?.pre_scrambl_flag === 1
    },
    notSaleNow() {
      // 暂未发售
      // e.g. 车次暂未发售，预计#18点#起售
      return this.saleFlag && !!this.trainInfo?.ticket_data
    },
    sellOut() {
      return !this.trainInfo?.ticket_data?.some((item) => item.ticket_num !== '无票')
    },
    trainCode() {
      return this.trainInfo?.train_code
    },
    iconStyle() {
      let iconUrl = 'https://dpubstatic.udache.com/static/dpubimg/ulWFQkV04P4SfK6xvcAXV.png'
      if (this.trainCode === this.current) {
        iconUrl = 'https://dpubstatic.udache.com/static/dpubimg/389YP5QC3OdnNwmhos8-V.png'
      } else if (this.include) {
        iconUrl = 'https://dpubstatic.udache.com/static/dpubimg/qAogfUs0LX-9PbaNNd9SP.png'
      }
      return { '--icon-url': `url("${iconUrl}")` }
    },
    showSilent() {
      return this.trainInfo.special_flag > 0
    },
    showFxh() {
      return this.trainInfo.fxh_flag?.indexOf('1') > -1 && !(this.showSilent && this.ShowZndc)
    },
    ShowZndc() {
      return this.trainInfo.fxh_flag?.indexOf('2') > -1
    },
    // 是否异站换乘
    isTransferDif() {
      return this.trainInfo?.transfer_station_type === 2 
    },
    transferSameText() {
      return this.isTransferDif ? '异站换乘' : '同站换乘'
    },
    // 换乘城市
    transferStation() {
      const station =
        (this.trainInfo?.transfer_station_type === 2
          ? this.trainInfo?.transfer_station_city_name
          : this.trainInfo?.transfer_station_name) || ''
      return `${station}转`
    },
    // 换乘停留时间
    transferTime() {
      return `停留${this.trainInfo?.transfer_stop_time || ''}`
    },
    // 中转两趟票务信息对象数组
    transferTikcetArr() {
      return this.trainInfo?.transfer_ticket || []
    },
    recommendTicket() {
      const ticket = this.trainInfo.recommend_ticket?.[0]
      return ticket && formatRecommendTicket(ticket)
    },
    recommendTicketDrawer() {
      return formatRecommendTicketDrawer(this.trainInfo)
    },
    isStudentType() {
      const { passenger_type } = getStorage(STORAGE_LIST_SEARCH_QUERY)
      return +passenger_type === 13
    },

  },
  methods: {
    getTimeFromDate(date) {
      if (date != null && date != '') {
        var time = parseDate(date)
        return formatDate(time, 'hh:mm')
      } else {
        return '--'
      }
    },
    getTemplate(color, text) {
      return {
        type: 'node',
        name: 'span',
        attrs: { style: `color: ${color}` },
        children: [{ type: 'text', text }]
      }
    },
    chooseTrain() {
      this.$trigger('goDetail')
    },
    transferTrainInfo(item) {
      const segment = item?.union_segment_index ?? 1
      const trainCode = item.train_code || ''
      return `${segment}程${trainCode}`
    },
    getSeatName(seatType) {
      const mapping = {
        '一等座': '一等',
        '二等座': '二等',
        '商务座': '商务',
        '高级软卧': '高软',
      };
      return mapping[seatType] || seatType
    }
  }
})
</script>

<style scoped lang="stylus">
@import '~@/mixins/stylus/color.styl'

.card
  display flex
  flex-direction column
  background white
  padding 14px 16px
  border-radius 16px
  box-sizing border-box
  position relative
.card-main
  display flex
  flex-direction column
  flex 1
.off-sale
  position absolute
  top 0
  left 0
  opacity 1
  width 64px
  height 16px
  color #1473FF
  font-size 10px
  line-height 12px
  background url('https://dpubstatic.udache.com/static/dpubimg/ZpTeWWF_G73r15nbsLxG4.png')
  background-size cover
  background-repeat no-repeat
  &-text
    padding 2px 0 2px 12px
.card-item
  height 48px
  display flex
  flex-direction row
  justify-content space-between
.train-info
  display flex
  flex-direction column
  &.start
    flex 1
  &.arrive
    flex 1
    text-align right
  &.center
    flex 1
    align-items center
    margin-top 2px
  &.price
    flex 1
    text-align right
    align-items flex-end
  .coupon-desc
    border-radius 3px
    font-family PingFangS-Medium
    font-size 9px
    font-weight normal
    line-height 9px
    margin 6px 0 2px
    color #FF6400
    border 0.5px solid #FFBC91
    padding 1.5px
  .original-price
    font-family PingFangSC-Medium
    font-weight 400
    font-size 9px
    color #999
  .transfer-top
    font-size 9px
    line-height 9px
    margin-top -3.5px
    margin-bottom 3px
  .transfer-center
    position relative
    display flex
    align-items center
    font-family PingFangSC-Medium
    font-size 11px
    font-weight 500
    line-height 11px
    text-align center
    border-radius 8px
    color #222
    .container
      display flex
      align-items center
      position relative
      background #fff
      padding 2.5px 6px
      z-index 2
      .icon
        height 9px
        width 8px
        margin-right 2px
      &::after
        position absolute
        content ''
        width 200%
        height 200%
        box-sizing border-box
        border 1px solid #ccc
        transform-origin 0 0
        transform scale(0.5)
        border-radius 8px
        top 0
        left 0
    .img
      width 100.5px
      height 3.5px
      position absolute
      top 50%
      left 50%
      transform translate(-50%, calc(-50% - 1px))
      z-index 1
  .transfer-bottom
    font-family PingFangSC-Regular
    font-size 9px
    font-weight 400
    line-height 9px
    display flex
    align-items center
    color #666
    margin-top 2.5px
    .transfer-different
      font-weight 500
      font-family PingFangSC-Medium
      color #333
.time
  font-size 22px
  color $train-color-333
  font-family Barlow Semi Condensed
  font-weight 400
  &.start
    font-size 22px
  &.arrive
    position relative
.day-diff
  position absolute
  font-size 11px
  right -25px
  top -4px
  color $train-color-666
.price
  color #FF6400
  font-weight 400
  font-family Barlow Semi Condensed
  &.large
    font-size 22px
  &.small
    font-size 14px
  &.noSeat
    font-size 16px
    color #BBBBBB
.station-name
  font-size 14px
  color $train-color-333
  font-family PingFangSC
.station-info
  font-size 11px
  color $train-color-666
  line-height 11px
  &-up
    margin-top 4.5px
    margin-bottom 5px
  &-bottom
    margin-top 5px
.train-code
  display flex
  flex-direction row
  align-items baseline
  min-height 20px
  &.start
    justify-content flex-start
    align-items center
  &.end
    justify-content flex-end
    align-items center
  .start-text
    font-size 11px
    margin-left 1px
    position relative
    top -1px
.silent
  background RGB(20, 115, 255, 0.1)
  font-size 8px
  font-weight 700
  color #438FFF
  border-radius 2px
  width 12px
  height 12px
  line-height 10px
  text-align center
  align-self center
  box-sizing border-box
  margin-left 2px
.station-dot
  border-radius 3px
  text-align center
  border 0.5px solid #CCCCCC
  // padding 1.5px
  width 11px
  height 11px
  text-align center
  line-height 12px
  font-size 9px
  color #888888
  &.from
    margin-left 3px
  &.to
    margin-right 3px
  &.fuxing
    width 30px
  &.zndc
    width 40px
.grid-container
  display grid
  grid-template-columns repeat(4, 1fr)
  margin-top 16px
  .grab-ticket
    color #FF4129
.ticket-style-1
  text-align center
.ticket-style-2
  text-align right
.ticket
  font-size 12px
  &.noTicket
    color $train-color-999
  &.hasTicket
    color $train-color-333
.sizebox
  height 6px
.img
  width 68px
  height 3px
.halt-sales-tips
  font-size 11px
  color #333333
  margin-top 10px
.sell-out-tips
  font-family PingFangSC-Regular
  font-size 11px
  line-height 13px
  color #FF4129
  margin-top 20px
.scramble-choose-icon
  width 19px
  height 19px
  background var(--icon-url)
  background-size cover
  background-repeat no-repeat
  margin 17px 4px 0 20px
.transfer-ticket-container
  display flex
  align-items flex-start
  margin-bottom 8px
  &:first-child
    margin-top 17px
  &:last-child
    margin-bottom 2px
  .placeholder
    min-width 50px
    margin-right 16px
    display flex
    .train-no
      padding 1.5px 2px
      background #F2F6F9
      border-radius 3px
      font-weight 400
      font-size 9px
      line-height 9px
      color #888
  .transfer-seat-container
    flex 1
    display grid
    grid-template-columns repeat(auto-fill, minmax(25%, 1fr))
    grid-row-gap 8px
    .transfer-seat
      font-size 11px
      font-weight 400
      line-height 11px
      white-space nowrap
      color #666
      &.gray
        color #999
      .seat-type
        margin-right 4px
</style>

<script name="json">
module.exports = {
  component: true,
  usingComponents: {
    'crossed-price': '@/components/crossed-price',
    'es-icon': '@didi/es-mpx-ui/lib/icon',
    'recommend-ticket': '@/components/recommend-ticket/index'
  }
}
</script>